import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from '../../../services/loading.service';
import { ToastrService } from 'ngx-toastr';
import { TrainingLocationTypeModel } from '../../../models/training/training-location-type.model';
import { IntegrationsService } from '../../../services/integration/integrations.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-zoom',
    imports: [],
    templateUrl: './zoom.component.html',
    styleUrl: './zoom.component.css'
})
export class ZoomComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private loadingService: LoadingService,
    private router: Router,
    private toastrService: ToastrService,
    private integrationsService: IntegrationsService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    const code = this.activatedRoute.snapshot.queryParams['code'] ?? null;

    if (code) {
      const obs = this.integrationsService.integrate(
        TrainingLocationTypeModel.Zoom,
        code,
        IntegrationsService.goToZoomRedirectUrl
      );
      this.loadingService.load(obs).subscribe(() => {
        this.toastrService.success(
          this.translateService.instant('INTEGRATIONS.ZOOM-INTEGRATION-SUCCESSFUL')
        );
        this.router.navigate(['integrations']);
      });
    } else {
      this.router.navigate([IntegrationsService.integrationsUrl])
    }
  }
}
